// extracted by mini-css-extract-plugin
export default {"container":"QuoteItem_container__HQtWL","details":"QuoteItem_details__x60Zu"};